const emailReg = /\w[-\w.+]*@([-A-Za-z0-9]+\.)+([A-Za-z0-9][-A-Za-z0-9]+\.)?[A-Za-z]{2,14}$/;

export default emailReg